"use client";

import { usePathname } from "next/navigation";
import MessagesBanner from "@/components/messages-banner";

/** Wraps the page content. Normally leaves 230px on the left for the Indices
 *  pane; on the full-width Documentation and User Guide pages that padding (and
 *  the pane) drop. */
export default function ContentShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const fullWidth = pathname.startsWith("/documentation") || pathname.startsWith("/user-guide");
  const pl = fullWidth ? "" : "pl-[230px]";
  return (
    <>
      <div className={`pt-[50px] ${pl}`}>
        <MessagesBanner />
      </div>
      <main className={`flex-1 pb-[50px] min-w-0 overflow-x-hidden ${pl}`}>{children}</main>
    </>
  );
}
